"use client"

import { useState } from "react"

type PasswordFieldProps = {
	label: string
	value: string
	onChange: (value: string) => void
	autoComplete?: string
	required?: boolean
}

export default function PasswordField({ label, value, onChange, autoComplete, required }: PasswordFieldProps) {
	const [visible, setVisible] = useState(false)

	return (
		<label className="text-xs font-bold text-[#00f5ff] block">
			{label}
			<div className="mt-1 relative">
				<input
					type={visible ? "text" : "password"}
					value={value}
					onChange={(e) => onChange(e.target.value)}
					required={required}
					autoComplete={autoComplete}
					className="w-full bg-black text-[#39ff14] border-2 border-t-[#ff003c] border-l-[#ff003c] border-b-[#00f5ff] border-r-[#00f5ff] pl-2 pr-8 py-1 text-sm outline-none"
				/>
				<button
					type="button"
					onClick={() => setVisible((v) => !v)}
					aria-label={visible ? "Hide password" : "Show password"}
					className="absolute right-1 top-1/2 -translate-y-1/2 text-sm leading-none px-1 hover:opacity-70"
				>
					{visible ? "🙈" : "👁️"}
				</button>
			</div>
		</label>
	)
}
